module.exports = __webpack_public_path__ + "img/mission-ideas-opportunities.78a26bee.svg";